module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SK - Slovakia.e9ce6ba6.svg";